<template>
  <v-container pa-10>
    <v-row align="center" justify="space-between" class="font-weight-black Barra_Breadcrumbs">
      <v-col cols="12">
        <v-breadcrumbs :items="breadcrumbs" divider="/">
          <v-breadcrumbs-item
            slot="item"
            slot-scope="{ item }"
            :key="item.nivel"
            :disabled="item.disabled">
              {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-col>
    </v-row>

    <notas-nivel-1-dados-agrupado
      ref="notasCardsAgrupados"
      @TABELA_EXPORTAR_DADOS="requestExportacao"
      :exibe-importador="false"
      @Notas__SelecionaItemNivel1="selectItem">
    </notas-nivel-1-dados-agrupado>
  </v-container>
</template>

<script>
import { generateComputed } from '@/common/functions/roles-computed-generator';
import exportacao from '@/common/functions/exportacao';
import NotasNivel1DadosAgrupado from './NotasNivel1DadosAgrupado';

export default {
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Notas',
          to: 'notas',
          disabled: true,
          nivel: 1,
        },
      ],
    };
  },
  components: {
    NotasNivel1DadosAgrupado,
  },
  computed: {
    ...generateComputed('NOTA', [
      'canAccessPage',
      'canAccessCRUD',
    ]),
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast(this.$t('message.acesso_negado'));
      }
    },
    selectItem(item) {
      this.adicionarItemBreadcrumbs(item);
      // retirando acesso a tela de nivel 2 de notas
      // this.$router.push({
      //   name: 'nivel2Notas',
      //   params: {
      //     visao: item.tipo,
      //     breadcrumbsParam: this.breadcrumbs,
      //   },
      // });
    },
    adicionarItemBreadcrumbs(item) {
      this.breadcrumbs[0].disabled = false;
      this.breadcrumbs.push({
        text: item.titulo,
        value: item,
        to: 'nivel2Notas',
        disabled: true,
        nivel: 2,
      });
    },
    requestExportacao(cb, nota, tipoNota = null,
      mesesSelecionados, tipoDataSelecionada, idFornecedor, idGrupoFornecedor) {
      const params = {
        meses: mesesSelecionados,
        modo_varejo: true,
      };

      if (tipoDataSelecionada === 'dataConferencia') {
        params.data_conferencia = true;
      } else if (tipoDataSelecionada === 'dataEmissao') {
        params.data_emissao = true;
      }

      if (tipoNota != null) {
        params.tipoNota = tipoNota;
      }
      if (idFornecedor != null) {
        params.idFornecedor = idFornecedor;
      }
      if (idGrupoFornecedor != null) {
        params.idGrupoFornecedor = idGrupoFornecedor;
      }

      if (nota.tipo === 'SELLIN') {
        exportacao.exportar(cb, 'notas_sellin_magalu', this, params, 5000, 0);
      } else if (nota.tipo === 'DEVOLUCAO') {
        exportacao.exportar(cb, 'notas_devolucao_magalu', this, params, 5000, 0);
      } else if (nota.tipo === 'SELLOUT') {
        exportacao.exportar(cb, 'notas_sellout_magalu', this, params, 10000, 0);
      }
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};
</script>
<style lang="scss">
.Barra_Breadcrumbs {
  .v-breadcrumbs {
    padding: 0.5em 0 1em 0;
  }
  ul:not(.md-list)>li+li {
    margin-top: 0 !important;
  }
}
</style>
